// Dohte basket selector - custom delivery week dropdown
function nextIndex(current,total){return(current+1)%total}
function prevIndex(current,total){return(current-1+total)%total}
function buildCartPayload(selections,deliveryWeekLabel){return{items:selections.filter(s=>s.quantity>0).map(s=>({id:s.variantId,quantity:s.quantity})),attributes:{'Semana de entrega':deliveryWeekLabel}}}

const DELIVERY_OPTIONS=[
  {value:'2026-11-30',label:'30 de Nov a 4 de Dez'},
  {value:'2026-12-07',label:'7 de Dez a 11 de Dez'},
  {value:'2026-12-14',label:'14 de Dez a 18 de Dez'},
  {value:'2026-12-21',label:'21 de Dez a 23 de Dez'}
];

function ensureDropdownStyles(){
  if(document.getElementById('dohte-delivery-dropdown-styles'))return;
  const style=document.createElement('style');
  style.id='dohte-delivery-dropdown-styles';
  style.textContent=`
    #delivery-week.dohte-native-select{position:absolute!important;opacity:0!important;pointer-events:none!important;width:1px!important;height:1px!important;overflow:hidden!important;}
    .dohte-week-dropdown{position:relative;width:100%;max-width:100%;z-index:20;}
    .dohte-week-dropdown__trigger{width:100%;min-height:40px;display:flex;align-items:center;justify-content:space-between;gap:14px;padding:9px 14px;border:1px solid #B1843D;border-radius:4px;background:#EEE5D4;color:#8A5A1F;font:inherit;text-align:left;cursor:pointer;box-sizing:border-box;}
    .dohte-week-dropdown__trigger::after{content:'';width:7px;height:7px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg) translateY(-2px);flex:0 0 auto;transition:transform .18s ease;}
    .dohte-week-dropdown.is-open .dohte-week-dropdown__trigger::after{transform:rotate(225deg) translate(-2px,-2px);}
    .dohte-week-dropdown__menu{position:absolute;left:0;right:0;top:calc(100% + 4px);margin:0;padding:5px;background:#EEE5D4;border:1px solid #D3AE71;border-radius:4px;box-shadow:0 8px 22px rgba(0,0,0,.14);z-index:9999;}
    .dohte-week-dropdown__menu[hidden]{display:none!important;}
    .dohte-week-dropdown__option{display:block;width:100%;padding:10px 12px;border:0;background:transparent;color:#1F3A34;font:inherit;text-align:left;cursor:pointer;border-radius:3px;}
    .dohte-week-dropdown__option:hover,.dohte-week-dropdown__option:focus{background:#E5D6BD;outline:none;}
    .dohte-week-dropdown__option[aria-selected='true']{font-weight:600;background:#E5D6BD;}
  `;
  document.head.appendChild(style);
}

function ensureQuantityInputStyles(){
  if(document.getElementById('dohte-quantity-input-styles'))return;
  const style=document.createElement('style');
  style.id='dohte-quantity-input-styles';
  style.textContent=`
    .basket-card__quantity input[data-quantity-value]{width:5.5rem;min-width:5.5rem;padding:.2rem .4rem;border:0;outline:0;background:transparent;color:rgb(var(--color-foreground));font:inherit;font-size:1.6rem;line-height:1;text-align:center;-moz-appearance:textfield;box-sizing:border-box;}
    .basket-card__quantity input[data-quantity-value]::-webkit-outer-spin-button,.basket-card__quantity input[data-quantity-value]::-webkit-inner-spin-button{margin:0;-webkit-appearance:none;}
  `;
  document.head.appendChild(style);
}

function ensureDeliveryOptions(root){
  const select=root.querySelector('#delivery-week');
  if(!select)return null;
  const placeholder=select.options[0]?.textContent?.trim()||'Selecione uma semana';
  const previous=select.value;
  select.innerHTML='';
  const blank=document.createElement('option');blank.value='';blank.textContent=placeholder;select.appendChild(blank);
  DELIVERY_OPTIONS.forEach(item=>{const o=document.createElement('option');o.value=item.value;o.textContent=item.label;select.appendChild(o)});
  if(DELIVERY_OPTIONS.some(o=>o.value===previous))select.value=previous;
  return {select,placeholder};
}

function initDeliveryDropdown(root){
  const setup=ensureDeliveryOptions(root);if(!setup)return null;
  const {select,placeholder}=setup;
  ensureDropdownStyles();
  select.classList.add('dohte-native-select');

  let dropdown=select.parentElement.querySelector('.dohte-week-dropdown');
  if(!dropdown){
    dropdown=document.createElement('div');
    dropdown.className='dohte-week-dropdown';
    dropdown.innerHTML=`<button type="button" class="dohte-week-dropdown__trigger" aria-haspopup="listbox" aria-expanded="false"><span>${placeholder}</span></button><div class="dohte-week-dropdown__menu" role="listbox" hidden></div>`;
    select.insertAdjacentElement('afterend',dropdown);
  }

  const trigger=dropdown.querySelector('.dohte-week-dropdown__trigger');
  const triggerText=trigger.querySelector('span');
  const menu=dropdown.querySelector('.dohte-week-dropdown__menu');
  menu.innerHTML='';

  DELIVERY_OPTIONS.forEach(item=>{
    const btn=document.createElement('button');
    btn.type='button';btn.className='dohte-week-dropdown__option';btn.setAttribute('role','option');btn.dataset.value=item.value;btn.textContent=item.label;btn.setAttribute('aria-selected',String(select.value===item.value));
    btn.addEventListener('click',()=>{
      select.value=item.value;
      triggerText.textContent=item.label;
      menu.querySelectorAll('.dohte-week-dropdown__option').forEach(x=>x.setAttribute('aria-selected',String(x===btn)));
      dropdown.classList.remove('is-open');menu.hidden=true;trigger.setAttribute('aria-expanded','false');
      select.dispatchEvent(new Event('change',{bubbles:true}));
    });
    menu.appendChild(btn);
  });

  if(select.value){const found=DELIVERY_OPTIONS.find(o=>o.value===select.value);if(found)triggerText.textContent=found.label}else triggerText.textContent=placeholder;

  if(trigger.dataset.bound!=='true'){
    trigger.dataset.bound='true';
    trigger.addEventListener('click',(event)=>{
      event.preventDefault();event.stopPropagation();
      const opening=menu.hidden;
      document.querySelectorAll('.dohte-week-dropdown.is-open').forEach(other=>{if(other!==dropdown){other.classList.remove('is-open');const m=other.querySelector('.dohte-week-dropdown__menu');const t=other.querySelector('.dohte-week-dropdown__trigger');if(m)m.hidden=true;if(t)t.setAttribute('aria-expanded','false')}});
      menu.hidden=!opening;dropdown.classList.toggle('is-open',opening);trigger.setAttribute('aria-expanded',String(opening));
    });
    document.addEventListener('click',(event)=>{if(!dropdown.contains(event.target)){dropdown.classList.remove('is-open');menu.hidden=true;trigger.setAttribute('aria-expanded','false')}});
    dropdown.addEventListener('keydown',(event)=>{if(event.key==='Escape'){dropdown.classList.remove('is-open');menu.hidden=true;trigger.setAttribute('aria-expanded','false');trigger.focus()}});
  }
  return select;
}

function initBasketSelector(root){
  ensureQuantityInputStyles();
  root.querySelectorAll('[data-image-track]').forEach(track=>{
    const viewport=track.closest('.basket-card__image-viewport');
    if(!viewport||track.dataset.selectorBound==='true')return;
    const prev=viewport.querySelector('[data-image-prev]'),next=viewport.querySelector('[data-image-next]');
    if(!prev||!next)return;
    track.dataset.selectorBound='true';
    const slides=track.children;
    let current=0;
    const render=()=>{const w=slides[0]?slides[0].getBoundingClientRect().width:0;track.style.transform=`translateX(-${current*w}px)`};
    prev.addEventListener('click',()=>{current=prevIndex(current,slides.length);render()});
    next.addEventListener('click',()=>{current=nextIndex(current,slides.length);render()});

    let touchStartX=0,touchStartY=0;
    viewport.addEventListener('touchstart',(event)=>{
      if(!window.matchMedia('(max-width: 749px)').matches||event.touches.length!==1)return;
      touchStartX=event.touches[0].clientX;touchStartY=event.touches[0].clientY;
    },{passive:true});
    viewport.addEventListener('touchend',(event)=>{
      if(!window.matchMedia('(max-width: 749px)').matches||!touchStartX||event.changedTouches.length!==1)return;
      const dx=event.changedTouches[0].clientX-touchStartX;
      const dy=event.changedTouches[0].clientY-touchStartY;
      touchStartX=0;touchStartY=0;
      if(Math.abs(dx)<45||Math.abs(dx)<=Math.abs(dy))return;
      current=dx<0?nextIndex(current,slides.length):prevIndex(current,slides.length);
      render();
    },{passive:true});

    window.addEventListener('resize',render);render();
  });
  root.querySelectorAll('[data-quantity-stepper]').forEach(stepper=>{
    if(stepper.dataset.selectorBound==='true')return;
    stepper.dataset.selectorBound='true';
    let valueEl=stepper.querySelector('[data-quantity-value]');
    const dec=stepper.querySelector('[data-quantity-decrease]'),inc=stepper.querySelector('[data-quantity-increase]');
    if(!valueEl||!dec||!inc)return;
    if(valueEl.tagName!=='INPUT'){
      const input=document.createElement('input');
      input.type='number';input.min='0';input.step='1';input.inputMode='numeric';
      input.value=stepper.dataset.quantity||valueEl.textContent.trim()||'0';
      input.setAttribute('data-quantity-value','');
      input.setAttribute('aria-label','Quantidade de cabazes');
      valueEl.replaceWith(input);valueEl=input;
    }
    const set=q=>{
      const parsed=Number.parseInt(q,10);
      const quantity=Number.isFinite(parsed)?Math.max(0,parsed):0;
      stepper.dataset.quantity=String(quantity);
      valueEl.value=String(quantity);
    };
    dec.addEventListener('click',()=>set(Number(stepper.dataset.quantity)-1));
    inc.addEventListener('click',()=>set(Number(stepper.dataset.quantity)+1));
    valueEl.addEventListener('input',()=>{
      if(valueEl.value===''){stepper.dataset.quantity='0';return;}
      set(valueEl.value);
    });
    valueEl.addEventListener('change',()=>set(valueEl.value));
    valueEl.addEventListener('focus',()=>valueEl.select());
    valueEl.addEventListener('keydown',event=>{if(['e','E','+','-','.',','].includes(event.key))event.preventDefault()});
    set(valueEl.value);
  });
  root.querySelectorAll('[data-contents-toggle]').forEach(toggle=>{if(toggle.dataset.selectorBound==='true')return;toggle.dataset.selectorBound='true';const id=toggle.getAttribute('aria-controls'),panel=id?document.getElementById(id):null;if(!panel)return;toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));panel.classList.toggle('is-open',!open)})});
  const weekSelect=initDeliveryDropdown(root);
  const submit=root.querySelector('[data-checkout-submit]');if(!submit||submit.dataset.selectorBound==='true')return;submit.dataset.selectorBound='true';submit.addEventListener('click',async()=>{const errorEl=root.querySelector('[data-checkout-error]');if(!errorEl||!weekSelect)return;errorEl.hidden=true;if(!weekSelect.value){errorEl.textContent=errorEl.dataset.invalidDateMessage;errorEl.hidden=false;return}const label=weekSelect.options[weekSelect.selectedIndex].textContent;const selections=Array.from(root.querySelectorAll('[data-quantity-stepper]')).map(s=>({variantId:Number(s.dataset.variantId),quantity:Number(s.dataset.quantity)}));const payload=buildCartPayload(selections,label);if(!payload.items.length){errorEl.textContent=errorEl.dataset.emptySelectionMessage;errorEl.hidden=false;return}submit.disabled=true;try{const a=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:payload.items})});if(!a.ok)throw new Error();const u=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:payload.attributes})});if(!u.ok)throw new Error();window.location.href='/cart'}catch(e){errorEl.textContent=errorEl.dataset.requestFailedMessage;errorEl.hidden=false;submit.disabled=false}})
}
function boot(){document.querySelectorAll('.basket-selector').forEach(initBasketSelector)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',e=>{const root=e.target.matches?.('.basket-selector')?e.target:e.target.querySelector?.('.basket-selector');if(root)initBasketSelector(root)});
